// extracted by mini-css-extract-plugin
module.exports = {"sideMenuLink":"SideMenu_sideMenuLink__2ao0E","separator":"SideMenu_separator__3XXm0"};